import {onFind} from "@elements/init-modules-in-scope";
import {removeClass, addClass, hasClass, on, closest, findIn, findAllIn, find} from '@elements/dom-utils';
import * as formValidation from "@elements/form-validation";
import {showNotification, clearAll} from "@elements/alert-notification";
import formDataEntries from 'form-data-entries';
import Modal from 'bootstrap/js/dist/modal';
import {resultTracking} from "@elements/tracking";

const selectors = {
    base: '.js-add-cart',
    input: '.js-add-cart__input',
    btn: '.js-add-cart__btn',
    loading: '.js-add-cart__loading',
    result: '.js-add-cart__result',
    form: '.js-add-cart__form',
    error: '.js-add-cart__error',
    errorMaxLength: '.js-add-cart__error-max-length',
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let btns = findAllIn(selectors.btn, baseElement);
        let input = findIn(selectors.input, baseElement);
        let loading = findIn(selectors.loading, baseElement);
        let form = findIn(selectors.form, baseElement);
        let errorMessage = findIn(selectors.error, baseElement);
        let errorMaxLength = findIn(selectors.errorMaxLength, baseElement);
        let url;

        btns.forEach((btn) => {
            on("click", function (event) {
                event.preventDefault();

                url = form.getAttribute("data-action");
                loading.removeAttribute('hidden');

                let data = new URLSearchParams(formDataEntries(form));

                if (btn.getAttribute("data-new-cart") === "true"){
                    url = btn.getAttribute("data-formaction")
                    input.setAttribute("required", true)

                    if (input.value === "" || input.value.length > 30){
                        addClass("is-invalid", input);
                        errorMaxLength.removeAttribute('hidden');
                        loading.setAttribute('hidden', true);
                    }else{
                        removeClass("is-invalid", input);
                        errorMaxLength.setAttribute('hidden', true);
                        submitForm(data, url, loading, baseElement, form)
                    }
                }else{
                    removeClass("is-invalid", input)
                    data.append("add-cart", btn.getAttribute("data-name"))
                    data.delete(input.name)

                    submitForm(data, url, loading, baseElement, form)
                }
            }, btn)
        })
    });
}

function submitForm(data, url, loading, baseElement, form){
    if (pendingRequest) {
        pendingRequest.abort();
        pendingRequest = null;
    }

    let pendingRequest = fetch( url, {
        method: "POST",
        body: data,
    });

    showNotification({closable: true});
    showNotification(pendingRequest);

    //close notification after 3 seconds => customer request workfront ticket: 1863705
    setTimeout(() => {
        clearAll();
    }, 3000);

    pendingRequest.then((res) => {
        return res.clone().json()
    }).then((res) => {
        if (res.success) {
            resultTracking(res)
            if(res.redirectUrl && !res.showExhaustModal){
                window.location.href = res.redirectUrl;
            } else if(form.getAttribute("data-force-reload") === "true"){
                window.location.reload()
            }else{
                let myModal = Modal.getInstance(closest("#dynamicModal", baseElement))
                myModal.hide();

                if (res.showExhaustModal) {
                    let exhaustModal = findIn("#exhaustModal", window.document);
                    let myExhaustModal = Modal.getOrCreateInstance(exhaustModal, {
                        backdrop: 'static',
                        keyboard: false
                    });

                    setTimeout(() => {
                        myExhaustModal.show();
                    }, 750);

                    if (res.redirectUrl) {
                        onFind('.js-exhaust-cart', function (element) {
                            element.setAttribute('href', res.redirectUrl);
                        });
                    }

                    onFind('.js-exhaust-tab', function (element) {
                        on('click', function () {
                            let tab = element.getAttribute('data-exhaust-tab');
                            let tabButton = findIn(`[data-tab-title="${tab}"]`, window.document);

                            myExhaustModal.hide();

                            setTimeout(() => {
                                tabButton.click();
                                let offset = 100;
                                let elementPosition = tabButton.getBoundingClientRect().top;
                                let offsetPosition = elementPosition + window.pageYOffset - offset;
                                window.scrollTo({
                                    top: offsetPosition,
                                    behavior: "smooth"
                                });
                            }, 750);
                        }, element);
                    });
                }
            }
        }

        loading.setAttribute('hidden', true);
    }).catch((error) => {
        if (error.name !== 'AbortError') {
            console.error(error);

            loading.setAttribute('hidden', true);
        }
    });
}
